import { observable, action, runInAction, toJS } from "mobx";
import * as TenantInfoAPI from "../../../api/pc/tenantInfo";
import * as LoginAPI from "../../../api/login";
import { setCookie, inApp, cloneObj, clearTeamsCookie, mainHost, getQueryString } from "../../../utils";
import { MDialog } from '@weapp/ui';
import { getLabel, weappSDK } from '@weapp/utils';
import { InviteCodeCheckType } from './type';
import { publicUrl } from "../../../constants";
const { toast } = MDialog;
export class mCreateTeamStore {
    @observable loginLoading = false;
    @observable createLimit = false;
    @observable formValue: any = {}

    @action
    init = () => {
        this.formValue = {
            teamName: '',
            phoneNumber: '',
            email: '',
            telephone: '',
            address: '',
            inviteCode: ''
        };
        let account = window.sessionStorage.getItem('passport_sign_account') || '';
        if (account && account !== 'undefined') {
            if (account.indexOf('@') !== -1) {
                this.formValue.email = account
            } else {
                this.formValue.phoneNumber = account
            }
        }
        this.formValue = { ...this.formValue };
    }
    @action
    onFormChange = (type: string, value: string | boolean) => {
        let formValue = toJS(this.formValue);
        //@ts-ignore
        formValue[type] = value;
        this.formValue = { ...formValue };
    };

    @action
    checkInviteCode = (params: InviteCodeCheckType) => {
        return new Promise((resolve, reject) => {
            TenantInfoAPI.checkInviteCode(params).then((result) => {
                if (result?.data?.errorMsg) {
                    toast({
                        content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
                    });
                    resolve(false)
                } else {
                    resolve(true)
                }
            })
        })
    }


    @action
    createTenant = (obj: any) => {
        if (!this.createLimit) {
            this.createLimit = true;
            this.loginLoading = true;

            if (inApp()) {
                TenantInfoAPI.appCreateTenant(obj).then((result: any) => {
                    runInAction(() => {
                        if (result?.data?.errorMsg) {
                            toast({
                                content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg),
                            });
                            this.createLimit = false;
                            this.loginLoading = false;
                        } else {
                            const thirdSkipBindAccount_params = JSON.parse(window.sessionStorage.getItem('thirdSkipBindAccount_params') as any);

                            if (thirdSkipBindAccount_params) {
                                LoginAPI.thirdteamsLogin(thirdSkipBindAccount_params).then((result: any) => {
                                    let result1 = result.result;
                                    if (result1 != null && result1.ETEAMSID != null && result1.ETEAMSID != "") {
                                        let host = window.location.hostname;
                                        let domain = host.substr(host.indexOf(".") + 1);
                                        clearTeamsCookie();
                                        setCookie('ETEAMSID', result1.ETEAMSID);
                                        setCookie('ETEAMSID', result1.ETEAMSID, domain);
                                        if (result1.employeeid) {
                                            weappSDK.register('login', (params: any) => {
                                                weappSDK.customSDK.invoke('login', params)
                                            })
                                            weappSDK.exec('login', {
                                                loginkey: result1.ETEAMSID,
                                                tenantid: result1.tenantkey,
                                                userid: result1.employeeid,
                                                username: result1.username,
                                                password: "",
                                                langid: result1.langType,
                                                cid: result1.cid,
                                                into: 1,
                                            }).then((res: any) => {
                                                console.log(res)
                                            })

                                        }
                                    } else if (result.actionMsg.message != null && result.actionMsg.message != "") {
                                        toast({
                                            content: result.actionMsg.message,
                                            mask: false,
                                            delay: 1000
                                        });
                                    }
                                }).catch((error) => {
                                    console.log(error);
                                });
                            } else {
                                const loginType = localStorage.getItem('e_login_type');
                                if (loginType === 'phoneNumber') {
                                    LoginAPI.phoneNumberOneKeyLogin({
                                        mobileLoginToken: localStorage.getItem('e_mobile_login_token')
                                    }).then(({status, data}) => {
                                        if (data.eteamsid != null && data.eteamsid != "") {
                                            let host = window.location.hostname;
                                            if (data.employeeId) {
                                                if (inApp()) {
                                                    LoginAPI.checkLoginTeams({ ETEAMSID: data.eteamsid }).then((teamsData: any) => {
                                                        if (teamsData.loginAccess === false) {
                                                            weappSDK.customSDK.invoke("openLink", {
                                                                url: `${window.passport_runInfo.weappUrl}/mobile/obstruct/login?userIdToken=${data.userIdToken}`,
                                                                openType: 2
                                                            })
                                                        } else {
                                                            weappSDK.register('login', (params: any) => {
                                                                weappSDK.customSDK.invoke('login', params)
                                                            })
                                                            weappSDK.exec("setItem", {
                                                                key: "loginFromLogout", // 存储的数据标识
                                                                value: "true",
                                                                isPublic: "0",//iOS用到，1登录后存储，0登录前存储
                                                            }).then((res: any) => {
                                                            });
                                                            // const username = window.sessionStorage.getItem('passport_sign_psw');
                                                            // const password = window.sessionStorage.getItem('passport_sign_account');
                                                            weappSDK.exec('login', {
                                                                loginkey: data.eteamsid,
                                                                tenantid: data.tenantkey,
                                                                userid: data.employeeId,
                                                                // username: username,
                                                                // password: password,
                                                                langid: data.langType,
                                                                cid: data.cid,
                                                                into: 1,
                                                            }).then((res: any) => {
                                                                console.log(res)
                                                            })
                                                        }
                                                    });
                                                } else {
                                                    let service = getQueryString("service");
                                                    if (service) {
                                                        window.location.href = service;
                                                    } else {
                                                        window.location.href = `${mainHost()}${publicUrl}${data.redicretModuleSource ? `?redirectModuleSource=${data.redicretModuleSource}` : ``}`;
                                                    }
                                                }
                                                this.loginLoading = false;
                                            }
                                        } else {
                                            this.loginLoading = false;
                                            toast({
                                                content: data.message,
                                                mask: false,
                                                delay: 1000
                                            });
                                        }
                                    })
                                } else {
                                    weappSDK.customSDK.invoke("getClientInfo", {
                                        success: (res: any) => {
                                            let appParams = {
                                                imei: res.deviceId,
                                                version: res.osVersion,
                                                secondImei: res.deviceId2,
                                                adviceInfo: res.clientModel,
                                                loginType: "app_account",
                                                username: window.sessionStorage.getItem('passport_sign_account') as string,
                                                password: window.sessionStorage.getItem('passport_sign_psw') as string
                                            }
                                            const loginObj = cloneObj(appParams);
                                            LoginAPI.newLogin(appParams).then((res: any) => {
                                                const result = res.data;
                                                if ("true" == result.succeed && (result.ETEAMSID != null && result.ETEAMSID != "")) {
                                                    let host = window.location.hostname;
                                                    let domain = host.substr(host.indexOf(".") + 1);
                                                    clearTeamsCookie();
                                                    // weappSDK.invoke("clearWebCaches", {
                                                    //     success: (res:any)=> {}
                                                    // });
                                                    setCookie('ETEAMSID', result.ETEAMSID);
                                                    setCookie('ETEAMSID', result.ETEAMSID, domain);
                                                    weappSDK.register('login', (params: any) => {
                                                        weappSDK.customSDK.invoke('login', params)
                                                    })
                                                    weappSDK.exec('login', {
                                                        loginkey: result.ETEAMSID,
                                                        tenantid: result.tenantkey,
                                                        userid: result.employeeid,
                                                        username: result.username,
                                                        password: loginObj.password,
                                                        langid: result.langType,
                                                        cid: result.cid,
                                                        into: 1,
                                                    }).then((res: any) => {
                                                        console.log(res)
                                                    })
                                                } else {
                                                    this.loginLoading = false;
                                                    toast({
                                                        content: result.message,
                                                        mask: false,
                                                        delay: 2000
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                            this.createLimit = false;
                            this.loginLoading = false;
                        }
                    });
                }).catch((error: any) => {
                    console.log(error);
                    this.createLimit = false;
                    this.loginLoading = false;
                });
            } else {
                TenantInfoAPI.createTenant(obj).then((result: any) => {
                    runInAction(() => {
                        if (result?.data?.errorMsg) {
                            toast({
                                content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
                            });
                        } else {
                            if (result?.data?.redirectUrl) {
                                window.location.href = result.data.redirectUrl;
                            }
                        }
                        this.createLimit = false;
                        this.loginLoading = false;
                    });
                });
            }






        }
    };
}

const instance = new mCreateTeamStore();

export default instance;
